module.exports = __webpack_public_path__ + "img/norris-hello.9e59b40.png";